<template>
  <ion-page style="opacity: 1;">
    <ion-content class="ion-padding-top bg-grad-content">
      <div id="notfound">
        <div class="notfound">
          <div class="notfound-404">
            <h1>404</h1>
          </div>
          <h2>
            Lo sentimos, la página que ha solicitado no ha sido encontrada
          </h2>
          <div class="home-btn" @click="$router.push({ name: 'home' })">
            Ir a Inicio
          </div>
          <div class="contact-btn" @click="$router.push({ name: 'contact' })">
            Contactenos
          </div>
          <div class="notfound-social">
            <a href="https://www.facebook.com/LIONMOTOS" target="_blank">
              <ion-icon
                icon="logo-facebook"
                size="large"
                color="medium"
              ></ion-icon>
            </a>
            <a href="https://www.instagram.com/lion_hol" target="_blank">
              <ion-icon
                icon="logo-instagram"
                size="large"
                color="medium"
              ></ion-icon>
            </a>
            <a href="https://wa.me/573213813097?text=" target="_blank">
              <ion-icon
                icon="logo-whatsapp"
                size="large"
                color="medium"
              ></ion-icon>
            </a>
            <a href="mailto:comercial1@lion.com.co">
              <ion-icon icon="mail" size="large" color="medium"></ion-icon>
            </a>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
  components: {},
  data(vm) {
    return {}
  },
  mounted() {},
  computed: {
    wHeight() {
      return window.innerHeight
    }
  },
  methods: {}
}
</script>

<style>
#notfound {
  position: relative;
}

#notfound .notfound-bg {
  position: absolute;
  width: 100%;
  height: 100%;
}

.notfound {
  max-width: 910px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
}

.notfound .notfound-404 {
  position: relative;
  height: 200px;
}

.notfound .notfound-404 h1 {
  font-family: 'Montserrat', sans-serif;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 220px;
  font-weight: 900;
  margin: 0px;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 10px;
}

.notfound h2 {
  font-family: 'Montserrat', sans-serif;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  margin-top: 20px;
  margin-bottom: 15px;
}

.notfound .home-btn,
.notfound .contact-btn {
  font-family: 'Montserrat', sans-serif;
  display: inline-block;
  font-weight: 700;
  text-decoration: none;
  background-color: transparent;
  border: 2px solid transparent;
  text-transform: uppercase;
  padding: 13px 25px;
  font-size: 18px;
  border-radius: 40px;
  margin: 7px;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}

.notfound .home-btn:hover,
.notfound .contact-btn:hover {
  opacity: 0.9;
}

.notfound .home-btn {
  color: rgba(255, 0, 36, 0.7);
  background: #fff;
}

.notfound .contact-btn {
  border: 2px solid rgba(255, 255, 255, 0.9);
  color: rgba(255, 255, 255, 0.9);
}

.notfound-social {
  margin-top: 25px;
}

.notfound-social > a > ion-icon {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: 40px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0px 6px;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}

@media only screen and (max-width: 767px) {
  .notfound .notfound-404 h1 {
    font-size: 182px;
  }
}

@media only screen and (max-width: 480px) {
  .notfound .notfound-404 {
    height: 146px;
  }
  .notfound .notfound-404 h1 {
    font-size: 146px;
  }
  .notfound h2 {
    font-size: 16px;
  }
  .notfound .home-btn,
  .notfound .contact-btn {
    font-size: 14px;
  }
}
</style>
